import Vue from "vue";
import Store from "@/store/index.js";
import Router from "vue-router";
import Main from '../views/Main.vue';
import Nosotros from '../views/Nosotros.vue';
import ClientesAusa from '../views/Clientes.vue';
import Servicios from '../views/Servicios.vue';
 import Par from '../views/Par.vue';
import Contacto from '../views/Contacto.vue';

Vue.use(Router);
const domain = Store.state.domain;


const router = new Router({
  mode: "history",
    routes: [
  {
        path: `${domain.domainName}/`,
        name: "Main",
       // redirect: `${domain.domainName}/`,
        component: Main
  },
  {
      path: `${domain.domainName}/Nosotros`,
   name: "Nosotros",
   component: Nosotros
  },
  {
      path: `${domain.domainName}/Servicios`,
    name: "Servicios",
    component: Servicios
   },
   {
       path: `${domain.domainName}/Par`,
    name:"Par",
    component: Par
   },
    {
        path: `${domain.domainName}/ClientesAusa`,
        name: "Clientes",
        component: ClientesAusa
    },
    {
        path: `${domain.domainName}/Contacto`,
        name: "Contacto",
        component: Contacto
    },
]
});

router.start
export default router;
